import * as R from 'ramda'
import { formatAmountForDisplay, formatDate } from 'src/utils'
import { matchSettleValues } from './helpers'
import * as types from './types'

export default {
  [types.PARAMS_TO_SEND](state) {
    return {
      // pagination
      limit: state.pagination.itemsPerPage,
      offset: (state.pagination.page - 1) * state.pagination.itemsPerPage,
      // filters
      status: state.filters.status,
      currency: state.filters.currency ?? null,
      bankAccountType: state.selectedTab
    }
  },
  [types.MATCHING_TO_SHOW](state) {
    return state.matchingData.map((matching) => ({
      id: matching.id,
      valueDate: formatDate(matching.valueDate, 'DD/MM/YYYY'),
      remainingAmount: formatAmountForDisplay(
        matching.remainingAmount,
        matching.currency
      ),
      receivedAmount: formatAmountForDisplay(
        matching.receivedAmount,
        matching.currency
      ),
      remitterName: matching.remitterName,
      reference: matching.reference,
      currency: matching.currency,
      dirty: matching.dirty,
      receiverBankAccount: matching.receiverBankAccount,
      bankAccountType: matching.bankAccountType,
      comments: matching.comments,
      rawRemainingAmount: matching.remainingAmount
    }))
  },
  [types.SETTLE_TOTAL_AMOUNT](state) {
    let selected = R.clone(state.selectedToSettle)
    const dataToSetTotal = matchSettleValues(
      state.newSettleAmountValue,
      selected
    )
    return dataToSetTotal.reduce((acc, item) => {
      return acc + item.invoiceData.amount
    }, 0)
  },
  [types.SETTLE_TOTAL_AMOUNT_ETP](state) {
    return state.selectedToSettleEtp.reduce((agg, payable) => {
      agg = agg + payable.amount

      return agg
    }, 0)
  },
  // Disable settle button if total amount > remaining amount
  [types.DISABLE_SETTLE_BUTTON](state, getters) {
    const total = getters[types.SETTLE_TOTAL_AMOUNT]
    return total > state.settle.paymentInfo.remainingAmount || total === 0
  },
  [types.INVALID_SETTLE_TOTAL_AMOUNT_ETP](state, getters) {
    const amountToSettle = getters[types.SETTLE_TOTAL_AMOUNT_ETP]
    const remainingAmount = state.settle.paymentInfo.remainingAmount
    const isAmountToSettleGreater = amountToSettle > remainingAmount
    const isAmountToSettleZero = amountToSettle === 0
    const settleValueZero = state.selectedToSettleEtp.some(
      (item) => item.amount === 0
    )

    return isAmountToSettleGreater || isAmountToSettleZero || settleValueZero
  }
}
